//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import check from "./CompareJsonTypeOf.js";

export default {
    name: "CompareJsonBody",
    components: {
        AQTooltip
    },
    props: {
        oldData: {
            type: [Object, Array]
        },
        newData: {
            type: [Object, Array]
        },
        merge: {
            type: [Object, Array]
        },
        indent: {
            type: Number,
            default: 1
        },
        needKey: {
            type: Boolean,
            default: true
        },
        objectType: {
            type: Boolean,
            default: true
        },
        showAllDiff: {
            type: Boolean,
            default: false
        },
        showMarkers: {
            type: Boolean,
            default: false
        },
        showTooltip: {
            type: Boolean,
            default: false
        },
        showAdded: {
            type: Boolean,
            default: false
        },
        showDeleted: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            availableClasses: ["item-upd", "item-del", "item-add"]
        };
    },
    computed: {
        getCompareProps() {
            return {
                showAllDiff: this.showAllDiff,
                showMarkers: this.showMarkers,
                showTooltip: this.showTooltip,
                showAdded: this.showAdded,
                showDeleted: this.showDeleted,
                indent: this.indent + 1
            };
        },
        getStyle() {
            return { textIndent: `${(this.indent + 1) * 40}px` };
        },
        checkForMarkers() {
            return this.showMarkers ? "" : "-no-marker";
        },
        checkToShowAdded() {
            return this.showAllDiff || this.showAdded;
        },
        checkToShowDeleted() {
            return this.showAllDiff || this.showDeleted;
        }
    },
    methods: {
        notTree(type) {
            return type !== "Object" && type !== "Array";
        },
        toggle(item) {
            item.show = !item.show;
        },
        isObject(type) {
            return type === "Object";
        },
        isArray(type) {
            return type === "Array";
        },
        comma(index) {
            if (index === this.merge.length - 1) {
                return "";
            }
            return ",";
        },
        getClass(type) {
            if (type === "Number") {
                return "item-number";
            }
            if (type === "String") {
                return "item-string";
            }
            if (type === "Boolean") {
                return "item-boolean";
            }
            if (type === "Undefined") {
                return "item-undefined";
            }
            if (type === "Null") {
                return "item-null";
            }
            return "";
        },
        getOldDataObj(item) {
            if (this.oldData.hasOwnProperty(item.key)) {
                if (check.isObject(this.oldData[item.key])) {
                    return this.oldData[item.key];
                }
            }
            return {};
        },
        getNewDataObj(item) {
            if (this.newData.hasOwnProperty(item.key)) {
                if (check.isObject(this.newData[item.key])) {
                    return this.newData[item.key];
                }
            }
            return {};
        },
        getOldDataArr(item) {
            if (this.oldData.hasOwnProperty(item.key)) {
                if (check.isArray(this.oldData[item.key])) {
                    return this.oldData[item.key];
                }
            }
            return [];
        },
        getNewDataArr(item) {
            if (this.newData.hasOwnProperty(item.key)) {
                if (check.isArray(this.newData[item.key])) {
                    return this.newData[item.key];
                }
            }
            return [];
        },
        getDiff(item, index, type) {
            const { oldData } = this;
            const { newData } = this;
            let response = "";
            if (this.objectType) {
                if (
                    oldData.hasOwnProperty(item.key)
          && newData.hasOwnProperty(item.key)
                ) {
                    if (
                        check.getType(oldData[item.key])
            !== check.getType(newData[item.key])
                    ) {
                        response = `item-upd${this.checkForMarkers}`;
                    } else if (
                        !check.isArray(oldData[item.key])
              && !check.isObject(oldData[item.key])
                    ) {
                        if (oldData[item.key] !== newData[item.key]) {
                            response = `item-upd${this.checkForMarkers}`;
                        }
                    }
                }
                if (
                    !type && oldData.hasOwnProperty(item.key)
          && !newData.hasOwnProperty(item.key)
                ) {
                    response = this.checkToShowDeleted ? (`item-del${this.checkForMarkers}`) : "hide-all-differences";
                }
                if (
                    !type && !oldData.hasOwnProperty(item.key)
          && newData.hasOwnProperty(item.key)
                ) {
                    response = this.checkToShowAdded ? (`item-add${this.checkForMarkers}`) : "hide-all-differences";
                }
            } else {
                if (
                    oldData.hasOwnProperty(item.key)
          && newData.hasOwnProperty(item.key)
                ) {
                    if (
                        check.getType(oldData[item.key]) !== check.getType(newData[item.key])
                    ) {
                        response = `item-upd${this.checkForMarkers}`;
                    } else if (
                        !check.isObject(oldData[item.key])
              && !check.isArray(oldData[item.key])
                    ) {
                        const itemValue = item.value && check.isString(item.value) ? item.value.replace(/['"]+/g, "") : item.value;
                        if (newData.includes(itemValue) && oldData.includes(itemValue)) {
                            response = "";
                        } else if (newData.includes(itemValue) && !oldData.includes(itemValue)) {
                            response = type ? "" : (this.checkToShowAdded ? (`item-add${this.checkForMarkers}`) : "hide-all-differences");
                        } else if (!newData.includes(itemValue) && oldData.includes(itemValue)) {
                            response = type ? "" : (this.checkToShowDeleted ? (`item-del${this.checkForMarkers}`) : "hide-all-differences");
                        }
                    }
                }

                if (
                    !type && oldData.hasOwnProperty(item.key)
          && !newData.hasOwnProperty(item.key)
                ) {
                    if (item.value && check.isString(item.value)) {
                        const itemValue = item.value.replace(/['"]+/g, "");
                        if (newData.includes(itemValue) && oldData.includes(itemValue)) {
                            response = "";
                        } else {
                            response = this.checkToShowDeleted ? (`item-del${this.checkForMarkers}`) : "hide-all-differences";
                        }
                    } else {
                        response = this.checkToShowDeleted ? (`item-del${this.checkForMarkers}`) : "hide-all-differences";
                    }
                }

                if (
                    !type && !oldData.hasOwnProperty(item.key)
          && newData.hasOwnProperty(item.key)
                ) {
                    if (item.value && check.isString(item.value)) {
                        const itemValue = item.value.replace(/['"]+/g, "");
                        if (newData.includes(itemValue) && oldData.includes(itemValue)) {
                            response = "";
                        } else {
                            response = this.checkToShowAdded ? (`item-add${this.checkForMarkers}`) : "hide-all-differences";
                        }
                    } else {
                        response = this.checkToShowAdded ? (`item-add${this.checkForMarkers}`) : "hide-all-differences";
                    }
                }
                if (!oldData.hasOwnProperty(item.key) && !newData.hasOwnProperty(item.key)) {
                    const itemValue = item.value && check.isString(item.value) ? item.value.replace(/['"]+/g, "") : item.value;
                    if (newData.includes(itemValue) && oldData.includes(itemValue)) {
                        response = "";
                    } else if (newData.includes(itemValue) && !oldData.includes(itemValue)) {
                        response = type ? "" : (this.checkToShowAdded ? (`item-add${this.checkForMarkers}`) : "hide-all-differences");
                    } else if (!newData.includes(itemValue) && oldData.includes(itemValue)) {
                        response = type ? "" : (this.checkToShowDeleted ? (`item-del${this.checkForMarkers}`) : "hide-all-differences");
                    }
                }
            }

            return response;
        }
    }
};
